var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_7943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    fill: "url(#pattern0_3_7943)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_7943)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    fill: "#FE3839"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3_7943",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_7943",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_7943",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL+SURBVHgB7ZtNTxNBGMf/z2yhAa9wLZFwwBDjoQS65UL8CKKGmy+cjJGLeJAPoDFw1ZOSeFKjCUc9GS6kLUkP6oUDicgJAl55W9jHWRJht22a7k6n1c78kqYzT2anff47z7zszAIWi8VkCJph1+3xmWYJPCWzI/LTW/cCoiMwfyfGa/Skl2hl5QQa0SoA5/MD7PMXmRxGMn5K4a5TsbgJTWgTgLPZLu5Or8u7OQg11sk7zlK5vA8NCOgilbrXBOcDhtGVfgRNpKAJJjETzsum/AG+/5DW1n7XvW5iIuOf+ItEuHVR11n/8QIa0BYCvps/lC0gff5Djhig1dWtRq6V4dPHXd27IdO+KBYuQQP6QiDkfECjzp+VLZf3Kky90IQ+Af4TqkKAcxO3Gf5LmexDZ7FFPuZorfAxbKxqAdL5BXSe8wEZFnhVaawVAtrird2w7EwrbVUCyGnrA/n1Cx0H7wmmx5XW2MOgn3M5nJfDk/b1RD1U/4/xo4AVAIZjBYDhWAFgOMYLoO2ByF9Ci6v9WosR1fKqaG8BocVVzcWIanlVWhECmVC6kVVm3PJK2E4QhmMFgOFYAWA4VgAYjhUAhmMFgOFYAWA4VgAYjhUA+jk/7iJ3MRs5JhO3vBLaBbjYbq+9Pa1aXhW7PQ7DsQIgPl44w9ls284U8dBQusIU+2R5EgF2ojWIEbSL/v5rkTzHHzViC0CgUrSG1A20DZqJZvkHYpKgBdByOMeEWXbdpO8DJIbHxi77zPfDNmLxCTGJL4B3GAiwHbL0MuPzwejoIFrEUS53hYXzlaKbu5vo6X6PmCQaw3k8P83E76JGPiEhlmTiDXZ3v9HGxhGaSNDZerK/cciZIkHB+wORztcH300Vi28Rk8STmFPXXSDGHP4BZBg+dwqFeSRAaRbH4+PPmMRTtBHp/KJ0/gkSojQRolJpnsi5gyD+Ws82gadVnA9oyjyeJydTpwfH0w7hprwjV5k5Q00+fSIn/J50eEfWWzoFlh3PW9b1IpXFYjGHP2l2As5366ocAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletei);
export default __webpack_public_path__ + "static/media/deletei.107a4d3f23c43f7ec8e46dbfd35b6847.svg";
export { ForwardRef as ReactComponent };